/*
 * Title: GentleProxy & List Obejct
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 */

import GentleApi from "../common/api";
import GentleAppState from "../common/appstate";
import GentleServiceAccount from "../service/account";
import GentleUtil from "../common/util";

let fromStandardDate = new Date();
var year = fromStandardDate.getFullYear();
fromStandardDate.setYear(year - 1);
const dt = new Date(fromStandardDate);
const yyyy = dt.getFullYear();
const mm = GentleUtil.pad(dt.getMonth() + 1, 2);
const dd = GentleUtil.pad(dt.getDate(), 2);
fromStandardDate = `${yyyy}${mm}${dd}`;
let toStandardDate = `${yyyy + 1}${mm}${dd}`;

var GentleProxyList = {
  login: {
    method: "post",
    // url:"/atomy-api/{JisaCode}/v1/account/auth",
    url: "/member/login",
    requestBody: {
      UserId: "",
      Password: "",
    },
  },
  logout: {
    login: true,
    method: "post",
    url: "/member/logout",
  },
  access_token: {
    method: "post",
    url: "/atomy-dev/auth/requestToken",
  },
  // 세션 확인
  svc_session: {
    method: "get",
    url: "/atomy-global-svc/auth/svc/jwt?_siteId=kr",
  },
  "sso-check": {
    method: "post",
    url: "/sso/sso-check",
    requestBody: {
      token: "",
    },
  },
  userinfo: {
    // 회원정보조회
    login: true,
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/account/{CustNo}",
  },
  "global-login": {
    method: "post",
    url: "/sso/global-login",
    requestBody: {
      id: "",
      password: "",
    },
  },
  "2025-login": {
    method: "post",
    url: "/atomy-dev/customerinfo",
    requestBody: {
      id: "",
      password: "",
    },
  },
  // 관심회원 목록
  "interestMember": {
    login: true,
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/account/{CustNo}/interest?PageNo={PageNo}&PageSize=10&SearchKeyword={SearchKeyword}",
  },
  "2025-interestMember": {
    login: true,
    method: "get",
    url: "/atomy-dev/chatbotInterestCustomer?page={PageNo}&searchKeyword={SearchKeyword}",
  },

  sponsor: {
    // 후원인 검색
    login: true,
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/account/{CustNo}/sponsor/{searchNo}",
  },
  easyjoin: {
    // 간편가입 등록
    login: true,
    method: "post",
    url: "/atomy-api/{JisaCode}/v1/account/easyjoin/make",
    requestBody: {
      CustNo: "", // S0000000
      HuwonNo: "", // S0000000
    },
  },
  notice: {
    // 공지사항목록
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/common/notice?PageNo={PageNo}&PageSize={PageSize}&IsCommonGubun={IsCommonGubun}&SearchCustNo={SearchCustNo}&SearchWGubun={SearchWGubun}&Mode={Mode}&IsReadyReOpenSearch={IsReadyReOpenSearch}&IsRegisterReOpenSearch={IsRegisterReOpenSearch}&Mode={Mode}",
  },
  "global-notice": {
    // 신 공지사항목록
    method: "get",
    url: "/atomy-global/csNotice/noticeList?_siteId=kr&locale=ko-KR&mainCategory={mainCategory}&apiKey=atomy1234!",
  },
  "2025-notice": {
    // 공지사항목록
    method: "get",
    url: "/atomy-dev/chatbot/content/searchNoticeList",
  },  
  center: {
    // 센터목록
    method: "get",
    url: "/atomy-global/{JisaCode}/v1/common/center?EduArea={EduArea}&PageNo={PageNo}&PageSize={PageSize}&SearchKeyword={SearchKeyword}",
  },
  "global-center": {
    // 신 센터목록
    method: "get",
    url: "/atomy-global/centerInformation/centerList?_siteId=kr&pageSize={curPage}&searchValue={SearchKeyword}&apiKey=atomy1234!",
  },
  "2025-center": {
    // 신 센터목록
    method: "get",
    url: "/atomy-dev/centerList?jisaCode={JisaCode}&page={curPage}&searchValue=",
  },  
  categories: {
    // 쇼핑몰 카테고리 목록
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/product/categories?MiddleClass=00&SmallClass=00",
  },
  categoriesLarge: {
    // 쇼핑몰 카테고리 목록
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/product/categories?LargeClass={LargeClass}&SmallClass=00",
  },
  "global-categories": {
    // 신 쇼핑몰 카테고리 목록
    method: "get",
    url: "/atomy-global/category/tree?upperId={upperId}&_siteId=kr&_deviceType=pc&locale=ko-kr",
  },
  "2025-categories": {
    // 쇼핑몰 카테고리 목록
    method: "get",
    url: "/atomy-dev/chatbot/disp/getDispCategoryList?upperDispCtgNo={upperId}",
  },
  "global-productRender": {
    // 신 쇼핑몰 카테고리 목록
    method: "get",
    url: "/atomy-global/product/items?_siteId=kr&_deviceType=pc&locale=ko-KR&categoryId={categoryId}",
  },
  "2025-productRender": {
    // 신 쇼핑몰 카테고리 목록
    method: "get",
    url: "/atomy-dev/chatbot/disp/getNextMiddleCategoryGoods?dispCtgNo={categoryId}",
  },
  searchkeywords: {
    // 제품인기키워드
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/product/searchkeywords",
  },
  //
  "global-searchkeywords": {
    // 제품인기키워드
    method: "get",
    url: "/atomy-global/atms/popularKeywords?_siteId=kr&_deviceType=pc&locale=ko_kr&apiKey=atomy1234!",
  },
  "2025-searchkeywords": {
    // 제품인기키워드
    method: "get",
    url: "/atomy-dev/chatbot/search/getPopularKeywords",
  },
  totalcount: {
    // 제품 총개수
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/account/{CustNo}/totalcount?PageNo={page}&PageSize={size}&SearchKeyword={keyword}&ShowGroupOption={option}",
  },
  productInCategory: {
    // 카테고리 안의 제품목록
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/product?PageNo={PageNo}&PageSize={PageSize}&LargeClass={LargeClass}&MiddleClass={MiddleClass}",
  },
  "global-productInCategory": {
    // 카테고리 안의 제품목록
    method: "get",
    url: "/atomy-global/product/item?productId={productId}&_siteId=kr&_deviceType=pc&locale=ko-KR",
  },
  "2025-productInCategory": {
    // 카테고리 안의 제품목록
    method: "get",
    url: "/atomy-dev/chatbot/disp/getNextMiddleCategoryGoods?dispCtgNo={productId}",
  },
  product: {
    // 제품목록
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/product?PageNo={PageNo}&PageSize={PageSize}&SearchKeyword={SearchKeyword}",
  },
  "global-product": {
    // 제품목록
    method: "post",
    url: "/atomy-global-post/atms/search?_siteId=kr&_deviceType=pc&locale=ko_kr&apiKey=atomy1234!",
    requestBody: {
      searchKeyword: "",
      sorting: "",
      from: "",
      size: "",
    },
  },
  "2025-product": {
    // 제품목록
    method: "post",
    url: "/atomy-dev/chatbot/search/searchDsGoods",
    requestBody: {
      searchKeyword: "",
      sorting: [],
    },
  },
  "recommend-product": {
    // 제품목록
    method: "get",
    url: "/atomy-global/atms/searchByCategoryApi?apiKey=atomy1234!&_siteId=kr&locale=ko-KR&_deviceType=pc&categoryId=204761723 261899260 260556780 155088260 65100767 167305396 178888625 164818108 150710736&page=1&pvFrom=0&pvTo={SearchPvRange}&sorting={sortingOption}",
    // url: "/atomy-api/{JisaCode}/v1/product?PageNo={PageNo}&PageSize={PageSize}&SearchPvRange={SearchPvRange}",
  },
  "product-detail": {
    // 제품상세
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/product/{Id}",
  },
  "global-product-detail": {
    // 제품상세
    method: "get",
    url: "/atomy-global/product/item?productId={Id}&_siteId=kr&_deviceType=pc&locale=ko-KR",
  },
  "2025-product-detail": {
    // 제품상세
    method: "get",
    url: "/atomy-dev/chatbot/goods/getGoodsDetail?goodsNo={goodsNo}",
  },
  best: {
    // 제품인기목록
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/product?PageNo={PageNo}&PageSize={PageSize}&ShowPopular=true",
  },
  new: {
    // 신상품목록
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/product?PageNo={PageNo}&PageSize={PageSize}&FilterType=1",
  },
  "global-new": {
    // 신상품목록
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/product?PageNo={PageNo}&PageSize={PageSize}&FilterType=1",
  },
  cartCount: {
    // 장바구니 갯수
    login: true,
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/product/{CustNo}/cart/totalcount",
  },
  cartList: {
    // 장바구니 목록
    login: true,
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/product/{CustNo}/cart",
  },
  "global-cartList": {
    // 장바구니 목록
    login: true,
    method: "get",
    url: "/atomy-global/cart/getCartForType?_siteId={JisaCode}&locale=ko_KR&cartType=GENERAL&channel=WEB",
  },
  "2025-cartList": {
    // 장바구니 목록
    login: true,
    method: "get",
    url: "/atomy-dev/cart/getCartList",
  },
  cartAdd: {
    // 장바구니 등록
    login: true,
    method: "post",
    url: "/atomy-api/{JisaCode}/v1/product/{CustNo}/cart",
    requestBody: {
      Qty: "",
      ProductInfo: {
        Id: "",
      },
    },
  },
  "global-cartAdd": {
    // 장바구니 등록
    login: true,
    method: "post",
    url: "/atomy-global-post/cart/addToCart?_siteId={JisaCode}&cartType=GENERAL&channel=WEB",
    requestBody: {
      cartType: "",
      channel: "",
      products: [{ product: "", optionProduct: "149271553", quantity: "" }],
    },
  },
  "2025-cartAdd": {
    // 장바구니 등록
    login: true,
    method: "post",
    url: "/atomy-dev/cart/addToCart",
    requestBody: {
      products: [{ goodsNo: "", quantity: "" }],
    },
  },  
  cartUpdate: {
    // 장바구니 수량 수정
    login: true,
    method: "put",
    url: "/atomy-api/{JisaCode}/v1/product/{CustNo}/cart",
    requestBody: {
      Qty: "",
      ProductInfo: {
        Id: "",
      },
    },
  },
  "global-cartUpdate": {
    // 장바구니 수량 수정
    login: true,
    method: "post",
    url: "/atomy-global-post/cart/updateQuantity?_siteId={JisaCode}&cartType=GENERAL&channel=WEB",
    requestBody: {
      entry: "",
      quantity: "",
    },
  },
  "2025-cartUpdate": {
    // 장바구니 수량 수정
    login: true,
    method: "post",
    url: "/atomy-dev/cart/updateQuantity",
    requestBody: {
      cartNo: "",
      quantity: "",
    },
  },  
  cartDel: {
    // 장바구니 삭제
    login: true,
    method: "delete",
    url: "/atomy-api/{JisaCode}/v1/product/{CustNo}/cart?productCodes={productCodes}",
  },
  "global-cartDel": {
    // 장바구니 삭제
    login: true,
    method: "post",
    url: "/atomy-global-post/cart/removeEntries?_siteId={JisaCode}&cartType=GENERAL&channel=WEB",
    requestBody: {
      entries: [""],
    },
  },
  "2025-cartDel": {
    // 장바구니 삭제
    login: true,
    method: "post",
    url: "/atomy-dev/cart/removeCart",
    requestBody: {
      cartNoList: [""],
    },
  },  
  orders: {
    // 주문목록뷰
    login: true,
    nomember: true, // 비회원 지원
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/orders/{CustNo}/order/view?PageNo={PageNo}&PageSize={PageSize}&startDate={startDate}",
    // url:"/atomy-api/{JisaCode}/v1/orders/{CustNo}/order/view?startDate={startDate}&PageNo={PageNo}&PageSize={PageSize}",
  },
  "global-orders": {
    // 주문목록뷰
    login: true,
    nomember: true, // 비회원 지원
    method: "get",
    url: "/atomy-global/order/searchOrderList?_siteId=kr&apiKey=atomy1234!&customerNo={CustNo}&period={period}&page={PageNo}&pageSize={PageSize}&locale=kr-KR",
    // url:"/atomy-api/{JisaCode}/v1/orders/{CustNo}/order/view?startDate={startDate}&PageNo={PageNo}&PageSize={PageSize}",
  },
  "2025-orders": {
    // 주문목록뷰
    login: true,
    method: "get",
    url: "/atomy-dev/order/searchOrderList?period={period}&pageIdx={pageIdx}&rowsPerPage={rowsPerPage}",
  },
  order: {
    // 주문상세
    login: true,
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/orders/{CustNo}/order/{SaleNum}",
  },
  "global-order": {
    // 주문상세
    login: true,
    method: "get",
    url: "/atomy-global/order/searchOrderDetail?_siteId=kr&apiKey=atomy1234!&id={id}&customerNo={CustNo}&userName={userName}&locale=kr-KR",
  },
  "2025-order": {
    // 주문상세
    login: true,
    method: "get",
    url: "/atomy-dev/order/searchOrderInfo?saleNum={saleNum}",
  },
  "nomember-token": {
    // 비회원 토큰 가져오기
    login: true,
    method: "get",
    url: "/atomy-api/kr/v1/external/pw",
  },
  nomember: {
    // 비회원주문
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/orders/non?saleNum={saleNum}&userName={userName}",
  },
  nomemberDetail: {
    // 비회원주문상세
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/orders/non/detail?saleNum={saleNum}&userId={userId}",
  },
  cardars: {
    // 승인잔액 조회
    login: true,
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/orders/{CustNo}/cardars?CardFirstNumber={CardFirstNumber}&CardLastNumber={CardLastNumber}&RecogNumber={RecogNumber}&SettleAmount={SettleAmount}&RecogDate={RecogDate}",
  },
  "global-cardars": {
    // 승인잔액 조회
    login: true,
    method: "post",
    url: "/atomy-global-post/datomy/getApprovalBalance?_siteId=kr&apiKey=atomy1234!",
    requestBody: {
      binAtFirst: "",
      binAtLast: "",
      approvalNumber: "",
      approvalDate: "",
      amount: "",
    },
  },
  "2025-cardars": {
    // 승인잔액 조회
    login: true,
    method: "post",
    url: "/atomy-dev/order/getApprovalBalance",
    requestBody: {
      binAtFirst: "",
      binAtLast: "",
      approvalNumber: "",
      approvalDate: "",
      amount: "",
    },
  },
  sale: {
    // 매출조회
    login: true,
    method: "get",
    url: "/atomy-api/mySales/getMySales?_siteId=kr&_deviceType=pc&locale=ko-KR",
  },
  mysales: {
    // 나의 매출조회
    login: true,
    method: "post",
    url: `/atomy-global-post/mySales/getMySalesHistoryDaily?_siteId=kr&apiKey=atomy1234!&custNo={CustNo}&fromStandardDate=${fromStandardDate}&toStandardDate=${toStandardDate}&rowcount=5&startItem=1&endItem=5`,
  },
  huwonbonus: {
    // 후원수당목록
    login: true,
    method: "get",
    // url:"/atomy-api/{JisaCode}/v1/sales/{CustNo}/huwonbonus/view?StartDate={StartDate}&EndDate={EndDate}&PageNo={page}&PageSize={size}",
    url: "/atomy-api/{JisaCode}/v1/sales/{CustNo}/huwonbonus/view?PageNo={PageNo}&PageSize={PageSize}",
  },
  "global-huwonbonus": {
    // 신 후원수당목록
    login: true,
    method: "get",
    // url:"/atomy-api/{JisaCode}/v1/sales/{CustNo}/huwonbonus/view?StartDate={StartDate}&EndDate={EndDate}&PageNo={page}&PageSize={size}",
    url: "/atomy-global/chatbot/getChatbotSponsorshipAllowance?_siteId=kr&custNo={CustNo}&SearchRecentBonusProcessHistory=1&DateQuerystring={StartDate}&StartDate={StartDate}&EndDate={EndDate}&StartDs={StartDate}&EndDs={EndDate}&PageNo=1&PageSize=10&CustNo={CustNo}&JisaCode=01&IpAddress&jisa=01",
  },
  bonus: {
    // 나의 수당목록
    login: true,
    method: "get",
    // url:"/atomy-api/{JisaCode}/v1/sales/S0019120/bonus",
    url: "/atomy-api/{JisaCode}/v1/sales/{CustNo}/bonus",
  },
  "global-bonus": {
    // 나의 수당목록
    login: true,
    method: "get",
    // url:"/atomy-api/{JisaCode}/v1/sales/S0019120/bonus",
    url: "/atomy-global/chatbot/getChatbotAllowanceHistory?_siteId=kr&custNo={CustNo}&Date={StartDate}&DateQuerystring={StartDate}&StartDate={StartDate}&EndDate={EndDate}&StartDs={StartDate}&EndDs={EndDate}&PageNo=1&PageSize=10&CustNo={CustNo}&JisaCode=01&IpAddress&jisa=01",
  },
  "2025-bonus": {
    // 나의 수당목록
    login: true,
    method: "get",
    url: "/atomy-dev/chatbotAllowanceHistory?jisaCode=01&startDate={StartDate}&endDate={EndDate}&page={PageNo}&pageSize={PageSize}",
  },
  schedule: {
    // 일정
    login: true,
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/member/{CustNo}/schedule?PageNo={PageNo}&PageSize={PageSize}&StartDate={StartDate}&EndDate={EndDate}",
    // url:"/atomy-api/{JisaCode}/v1/member/{CustNo}/schedule?PageNo={PageNo}&PageSize={PageSize}&StartDate={StartDate}&EndDate={EndDate}",
  },
  "global-schedule": {
    // 일정
    login: true,
    method: "get",
    url: "/atomy-global/chatbot/getChatbotMySchedule?_siteId=kr&custNo={CustNo}&HasBonusPaymemt=false&HasHuwonBonus=false&HasEducation=false&HasHolyday=false&DateQuerystring={StartDate}&StartDate={StartDate}&EndDate={EndDate}&StartDs={StartDs}&EndDs={EndDs}&PageNo=1&PageSize=10&CustNo={CustNo}&JisaCode=01&IpAddress&jisa=01",
  },
  "2025-schedule": {
    // 일정
    login: true,
    method: "get",
    url: "/atomy-dev/chatbot/myoffice/getMyScheduleList?startDate={StartDate}&endDate={EndDate}&page={PageNo}&pageSize={PageSize}&HasBonusPayment={HasBonusPayment}&HasHuwonBonus={HasHuwonBonus}&HasEducation={HasEducation}&HasHolyday={HasHolyday}",
  },
  seminar: {
    // 세미나
    method: "get",
    url: "/atomy-external/{JisaCode}/v1/atomyticket/seminar?StartDate={StartDate}&EndDate={EndDate}",
  },
  "2025-seminar": {
    // 세미나
    method: "get",
    url: "/api-ticket/api/chat/v1/list?systemJisa=KR&startDate={StartDate}&endDate={EndDate}",
  },
  grouptree: {
    // 하위회원조회
    login: true,
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/sales/{CustNo}/grouptree?PageNo={PageNo}&PageSize=10&SearchKeyword={SearchKeyword}&SearchLevel=100",
  },
  "change-view": {
    // 판매일자변경 조회
    login: true,
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/orders/{CustNo}/order/{SaleNum}/change",
  },
  change: {
    // 판매일자변경
    login: true,
    method: "put",
    url: "/atomy-api/{JisaCode}/v1/orders/{CustNo}/order/{SaleNum}/change/saledate?isSaleM={isSaleM}",
  },
  "global-change": {
    // 판매일자변경
    login: true,
    method: "post",
    url: "/atomy-global/order/modifications?_siteId=kr&apiKey=atomy1234!",
  },
  "2025-change": {
    // 판매일자변경
    login: true,
    method: "post",
    url: "/atomy-dev/order/changeSaleDate",
  },
  myinfo: {
    // 이미지등록
    login: true,
    method: "post",
    url: "/atomy-korea/v2/home/myinfo/InputMyIntroChatbot",
  },
  recent: {
    // 최근정산 시간 조회
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/sales/process/recent",
  },
  "global-recent": {
    // 최근정산 시간 조회
    method: "get",
    url: "/atomy-global/chatbot/getChatbotRecentSettlementTime?_siteId=kr&jisa=01",
  },
  "2025-recent": {
    // 최근정산 시간 조회
    method: "get",
    url: "/atomy-dev/chatbotRecentSettlementTime",
  },
  mastership: {
    // 직급내역뷰
    login: true,
    method: "get",
    url: "/atomy-api/{JisaCode}/v1/sales/{CustNo}/mastership/view?SearchSalesMasterAchievement={SearchSalesMasterAchievement}&StartDate={StartDate}&EndDate={EndDate}&PageNo={PageNo}&PageSize={PageSize}",
  },
  "global-mastership": {
    // 신 직급내역뷰
    login: true,
    method: "get",
    url: "/atomy-global/chatbot/getChatbotLevelHistory?_siteId=kr&custNo={CustNo}&SearchSalesMasterAchievement={SearchSalesMasterAchievement}&DateQuerystring={StartDate}&StartDate={StartDate}&EndDate={EndDate}&StartDs={StartDate}&EndDs={EndDate}&PageNo=1&PageSize=10&CustNo={CustNo}&JisaCode=01&IpAddress&jisa=01",
  },
  "2025-mastership": {
    // 신 직급내역뷰
    login: true,
    method: "get",
    url: "/atomy-dev/chatbotLevelHistory?startDate={StartDate}&endDate={EndDate}&&SearchSalesMasterAchievement={SearchSalesMasterAchievement}",
  },
  upload: {
    // 이미지 업로드
    login: true,
    method: "post",
    url: "/atomy-korea/v2/home/myinfo/InputMyIntroChatbot",
    file: true,
  },
  sso: {
    // SSO Token
    method: "post",
    url: "/atomy-auth/{JisaCode}/v1/sso/request",
  },
  ssologin: {
    method: "post",
    url: "/member/ssologin",
  },
  enomix: {
    // enomix
    method: "post",
    url: "/enomix-proxy/proxy",
    contentType: "application/x-www-form-urlencoded",
  },
  "enomix-upload": {
    // enomix-image-upload
    method: "post",
    url: "/enomix-proxy/proxy?domainId=NODE0000000001&serviceType=SVTLK",
    contentType: "multipart/form-data"
  },
};

var GentleProxy = Object.create(GentleProxyList, {
  proxy: { writable: true, configurable: false, enumerable: true },
  JisaCode: { writable: true, configurable: false, enumerable: true },
  CustNo: { writable: true, configurable: false, enumerable: true },
});

GentleProxy.proxyInit = function (proxy, JisaCode, CustNo) {
  this.proxy = proxy;
  this.JisaCode = JisaCode;
  this.CustNo = CustNo;
};

GentleProxy.getMethod = function () {
  return this[this.proxy].method;
};

GentleProxy.getProxyUrl = function (param) {
  if (this[this.proxy].login && GentleAppState.isLogin === false) {
    GentleUtil.removeSlidePopup();
    GentleServiceAccount.login({
      fallback: "true",
      // nomember:this[this.proxy].nomember
      proxy: this.proxy,
    });
    return;
  }

  let url = this[this.proxy].url;
  const method = this[this.proxy].method;

  const opt = {
    JisaCode: "01", // this.JisaCode, 무조건 kr
    CustNo: this.CustNo,
  };

  url = url.GentleFormat(opt);

  if (method === "get" || method === "put" || method === "delete") {
    url = url.GentleFormat(param);
    url = encodeURI(url);
  }

  return url;
};

GentleProxy.getProxyRequestBody = function () {
  return this[this.proxy].requestBody;
};

/*
api : 
body : 
param : Get방식의 파라미터 변수. 생략가능
*/
GentleProxy.setApi = function (api, param) {
  // const api = Object.create(GentleApi);
  api.method = this.getMethod();
  api.contentType = this[this.proxy].contentType;

  if (api.method === "post" || api.method === "put") api.requestBody = param;

  const url = this.getProxyUrl(param);
  if (url) api.url = url;
  else return false;

  console.log("setAPI", api);

  return true;
};

GentleProxy.requestEx = function ({ proxy, param, onSuccess, onFailed, onAlways, isHidden, onError }) {

  GentleProxy.request(
    proxy,
    param,
    onSuccess,
    onFailed,
    onAlways,
    isHidden,
    onError
  );
};

GentleProxy.request = function (
  proxy,
  param,
  onSuccess,
  onFailed,
  onAlways,
  isHidden,
  onError
) {
  console.log('proxy>', proxy);
  console.log('param>', param);

  if (isHidden || window.chatbotConsulting) {
    // 숨기기나 상담중이라면
    // do nothing
  } else {
    window.ChatConsole.loadingBox(true);
  }

  // const JisaCode = GentleAppState.lang === "kr" ? "kr" : "us";
  // 2025.2 --->
  const JisaCode = "01";
  
  const CustNo = GentleAppState.custNo;

  const api = Object.create(GentleApi);
  this.proxyInit(proxy, JisaCode, CustNo);

  api.contentType = proxy.contentType;

  const res = this.setApi(api, param);
  if (res === false) {
    // 요청불가 (로그인 필요 등등...)
    window.ChatConsole.loadingBox(false);
    GentleUtil.serviceLoadingHide();

    return;
  }

  api.onSuccess(onSuccess);
  api.onFailed(onFailed);
  api.onAlways(onAlways);
  api.onError(onError);
  if (proxy === "enomix" || proxy === "enomix-upload") {
    console.log("enter enomix");
    api.sendeno();
  } else {
    console.log("no enomix");
    api.send();
  }
};

GentleProxy.requestFormData = function (
  proxy,
  form,
  onSuccess,
  onFailed,
  onAlways,
  isHidden,
  onError
) {
  console.log("proxy>", proxy);
  console.log("form>", form);
  let obj = {
    url: "",
    form: form,
    callback: "",
  };

  if (isHidden || window.chatbotConsulting) {
    // 숨기기나 상담중이라면
    // do nothing
  } else {
    window.ChatConsole.loadingBox(true);
  }

  const JisaCode = GentleAppState.lang === "kr" ? "kr" : "us";
  const CustNo = GentleAppState.custNo;

  const api = Object.create(GentleApi);
  this.proxyInit(proxy, JisaCode, CustNo);

  api.contentType = proxy.contentType;
  // api.contentType = 'multipart/form-data'

  const res = this.setApi(api, form);
  if (res === false) {
    // 요청불가 (로그인 필요 등등...)
    window.ChatConsole.loadingBox(false);
    GentleUtil.serviceLoadingHide();

    return;
  }

  api.onSuccess(onSuccess);
  api.onFailed(onFailed);
  api.onAlways(onAlways);
  api.onError(onError);
  api.sendMutipartFormData(obj);
};

GentleProxy.requestBaseTime = function (callback) {
  const pageSize = 5;

  const onSuccess = function (data) {
    switch (data.result) {
      case "200":
        const { item } = data;
        const { Date } = item;
        callback(Date.split(":")[0]); // 2021-06-28 07:40 에서 분단위 버림
        break;
      default:
        break;
    }
  };

  const onFailed = function (data) {
    console.log("onFailed");
  };

  const proxy = Object.create(GentleProxy);
  // proxy.request("global-recent", {}, onSuccess, onFailed);
  proxy.request("2025-recent", {}, onSuccess, onFailed);
}

GentleProxy.requestUserInfo = function (callback) {
  const onSuccess = function (data) {
    console.log("onSuccess>", data);
    switch (data.Status) {
      case 1:
        const { Data } = data;
        console.log("Data>", Data);
        callback(Data);
        // render(Data);
        break;
      default:
        break;
    }
  };

  const onFailed = function (data) {
    console.log("onFailed");
  };

  const proxy = Object.create(GentleProxy);
  proxy.request("userinfo", {}, onSuccess, onFailed);
};

export default GentleProxy;
